import React from "react";
import { useParams, Navigate } from "react-router-dom";
import SectionTitle from "../components/SectionTitle";
import useSeo from "../hooks/useSeo";
import { business } from "../data/content";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    script: "Your trust matters.",
    body: [
      "Soft Petal Electrolysis (\u201cwe,\u201d \u201cus,\u201d \u201cour\u201d) is committed to protecting the privacy of every person who visits our website or reaches out to us.",
      "**Information we collect.** We only collect what you choose to share via our contact form or booking flow: name, email, phone number, preferred contact method, treatment area (optional), and your message. We do not knowingly collect sensitive health information through the contact form.",
      "**How we use your information.** We use your information solely to respond to inquiries, schedule appointments, and provide you with information about our services.",
      "**How we store it.** Contact submissions are handled by our website provider (Netlify Forms) and are only accessed by authorized team members.",
      "**Your choices.** You can request that we remove your information at any time by emailing us.",
      "This starter policy is editable, please review and customize with your attorney before publishing.",
    ],
  },
  terms: {
    title: "Terms and Conditions",
    script: "Care with clarity.",
    body: [
      "By using this website or booking a service with Soft Petal Electrolysis, you agree to the following terms.",
      "**Services.** Descriptions of our services, sessions, and pricing are for informational purposes. Recommended session lengths depend on your treatment area, hair-growth cycle, and goals.",
      "**No medical claims.** Electrolysis is a cosmetic treatment. We do not diagnose or treat medical conditions.",
      "**Cancellations.** Please review our cancellation and late-arrival policies on the Pricing page.",
      "**Content.** All logos, images, and text on this site are the property of Soft Petal Electrolysis unless otherwise noted.",
      "This starter document is editable, please review and customize with your attorney before publishing.",
    ],
  },
  accessibility: {
    title: "Accessibility Statement",
    script: "Everyone welcome.",
    body: [
      "Soft Petal Electrolysis is committed to making this website accessible to everyone.",
      "**Standards.** We aim to conform with WCAG 2.1 Level AA guidelines.",
      "**Ongoing improvement.** Accessibility is an ongoing effort. If you find something that doesn\u2019t work well for you, please let us know so we can improve.",
      "**Contact.** Email us at " + business.email + " with any feedback or requests.",
    ],
  },
};

export default function Legal() {
  const { slug } = useParams();
  const doc = CONTENT[slug];
  useSeo({
    title: doc ? `${doc.title} | Soft Petal Electrolysis` : "Soft Petal Electrolysis",
    description: doc
      ? `${doc.title} for Soft Petal Electrolysis in ${business.city}, ${business.state}. Read our editable starter document.`
      : undefined,
    path: `/legal/${slug || ""}`,
  });

  if (!doc) return <Navigate to="/" replace />;

  return (
    <section className="py-16 lg:py-14">
      <div className="max-w-3xl mx-auto px-6 sm:px-10">
        <SectionTitle eyebrow="Legal" title={doc.title} scriptWord={doc.script} align="left" />
        <div className="mt-10 space-y-5 font-body text-charcoal-soft leading-relaxed">
          {doc.body.map((p, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: p.replace(/\*\*(.+?)\*\*/g, "<strong class='text-charcoal font-medium'>$1</strong>") }} />
          ))}
        </div>
      </div>
    </section>
  );
}
